import { Divider } from '@mui/material';
import { Grid } from '../layout';
import { Products } from './Products';
import { Equipment } from './Equipment';
import { Type } from './Type';
import { Crop } from './Crop';
import { Nitrogen } from './Nitrogen';
import { Sulfur } from './Sulfur';
import { Mode } from './Mode';
import { Year } from './Year';
import { Summary } from './Summary';

export function StarterFertilizerInputs() {
  return (
    <Grid columns={1} spacing={{ xs: 2, sm: 3 }}>
      <Products />
      <Divider />
      <Equipment />
      <Divider />
      <Type />
      <Divider />
      <Crop />
      <Divider />
      <Nitrogen />
      <Sulfur />
      <Divider />
      <Year />
      <Divider />
      <Mode />
      <Summary />
    </Grid>
  );
}
